import { render, staticRenderFns } from "./InvoiceItemsTable.vue?vue&type=template&id=d985d064&"
import script from "./InvoiceItemsTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemsTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemsTable.vue?vue&type=style&index=0&id=d985d064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports